import { ChartBarIcon, ClockIcon, CurrencyDollarIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import React from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

export interface BenefitCard {
  id: number;
  title: string;
  icon: React.ReactNode;
}

interface KeyBenefitsSectionProps {
  title?: string;
  benefits: BenefitCard[];
}

const KeyBenefitsSection: React.FC<KeyBenefitsSectionProps> = ({ title = "Foreign Exchange", benefits }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-white via-blue-50 to-blue-300 relative overflow-hidden">
      <div className="container mx-auto">
        <h2 className="text-4xl font-semibold mb-4">{title}</h2>
        <h3 className="text-3xl font-light italic mb-16">Key Benefits</h3>

        <div className="overflow-hidden">
          <Swiper
            spaceBetween={16}
            slidesPerView={1.1}
            centeredSlides={false}
            className="!px-4 md:!px-0"
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 24,
              },
            }}
          >
            {benefits.map((benefit) => (
              <SwiperSlide key={benefit.id}>
                <div className="bg-white rounded-3xl p-8 h-full shadow-sm">
                  <div className="flex items-center gap-6">
                    <div className="flex-shrink-0">
                      <div className="w-14 h-14 bg-[#7F84F6] rounded-full flex items-center justify-center text-white">{benefit.icon}</div>
                    </div>
                    <p className="text-base text-gray-800">{benefit.title}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default KeyBenefitsSection;
